import _ from "lodash";

export function sentenceCase(str: string) {
  if (!str) return "";
  const strInTitleCase = _.startCase(_.camelCase(str));
  return strInTitleCase[0] + strInTitleCase.slice(1).toLowerCase();
}
